<div id="attribute">
    <div fxLayout="row" fxLayoutAlign="space-between center"
        class="padding-10 color-gray font-white-color fixed-header">
        <span>Payment History</span>

        <button [attr.guide]="'view-deals-payment-btn-1' + '__' + sanitizedUrl" mat-dialog-close mat-icon-button>
            <mat-icon>
                close
            </mat-icon>
        </button>
    </div>


    <div>
        <div class="container">
            <div class="card m-5 p-3">
                <div class="card-body">
                    <table class="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Reference No</th>
                                <th>Amount</th>
                                <th>Notes</th>

                            </tr>
                        </thead>
                        <tbody *ngFor="let row of dealsList; let i=index;">
                            <td>{{ row.date | calsoftDate }}</td>
                            <td>{{ row.referenceNo }}</td>
                            <td>{{ row.amount }}</td>
                            <td>{{ row.note }}</td>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>


    </div>